import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { REQUIRED_DOCUMENT_LINKS } from './constants'

export const MFORequiredDocuments = () => (
  <ul className="landingFAQ__answerList">
    {REQUIRED_DOCUMENT_LINKS.map(({ url, text }) => (
      <li key={url} className="landingFAQ__answerListItem">
        <CommonLink url={url} className="color_green underline underline_green">
          {text}
        </CommonLink>
      </li>
    ))}
  </ul>
)
